import { render, staticRenderFns } from "./ShowAllExpander.vue?vue&type=template&id=2ca0bf8c&scoped=true&"
import script from "./ShowAllExpander.vue?vue&type=script&lang=ts&"
export * from "./ShowAllExpander.vue?vue&type=script&lang=ts&"
import style0 from "./ShowAllExpander.vue?vue&type=style&index=0&id=2ca0bf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0bf8c",
  null
  
)

export default component.exports